<template>
    <div class="qr-code-hot-container">
        <div class="main-box">
            <div class="main">
                <div class="img-box">
                    <img :src="qrcode" alt="">
                </div>
                <!-- <p class="s-s">扫一扫</p> -->
                <p class="column-code-name">关注{{columnName=='首页'?'湾潮':columnName}}公众号</p>
                <p class="tips">时刻掌握最新资讯</p>
            </div>
        </div>
        <div class="hot-list-box">
            <div class="hot-titles">
                <div>&nbsp;</div>
                <div class="title">热门公众号</div>
                <div class="more">更多</div>
            </div>
            <ul class="hot-list">
                <li v-for="(item, i) in hotList" :key="i">
                    <span class="dian">·</span>
                    <span class="name">{{item.name}}</span>
                    <span class="shu">|</span>
                    <span class="info">{{item.info}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'QrCodeHot',
    props: ['columnId', 'columnName', 'qrcode'],
    data() {
        return {
            hotList: [
                {
                    name: '产经',
                    info: '大湾区的产业动态'
                },
                {
                    name: '城市融媒体',
                    info: '9+2城市的新闻资讯'
                },
                {
                    name: '娱乐',
                    info: '吃娱乐圈最好磕的瓜'
                },
                {
                    name: '生活',
                    info: '根据你的喜好，推荐你喜爱的生活圈'
                },
                {
                    name: '时尚',
                    info: '我的时尚，只有你能懂'
                },
                {
                    name: '吃货',
                    info: '带上你的胃，我们做快乐的小吃货'
                }
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
@import './QrCodeHot.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/qr-code/QrCodeHot.vue